import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { ConfigurationField } from "../../types";

import { Label } from "@/components/ui/v2/label";
import { NumberInput } from "@/components/ui/v2/number-input";

export function NumberField({
  field,
  disabled,
}: {
  field: Extract<ConfigurationField, { type: "number" }>;
  disabled?: boolean;
}) {
  const { t } = useTranslation();
  const { setValue, watch } = useFormContext();
  const rawValue = watch(field.key);
  const numericValue = rawValue != null && rawValue !== "" ? Number(rawValue) : null;
  const handleChange = (value: number | null) => {
    setValue(field.key, value != null ? String(value) : "", { shouldValidate: true });
  };
  return (
    <div className="space-y-2">
      <Label htmlFor={field.key}>
        {t(field.label)}
        {field.required && <span className="text-destructive ml-1">*</span>}
      </Label>
      <NumberInput value={numericValue} onChange={handleChange} disabled={disabled} />
    </div>
  );
}
